import { render } from "./LeavePeriod.vue?vue&type=template&id=2f2450e0&scoped=true"
import script from "./LeavePeriod.vue?vue&type=script&lang=js"
export * from "./LeavePeriod.vue?vue&type=script&lang=js"

import "./LeavePeriod.vue?vue&type=style&index=0&id=2f2450e0&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/gmX3YL_q/0/internal/hrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f2450e0"]])

export default __exports__